import React from "react"

interface SelectProps extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    options: { value: string, label: string }[],
    className: string,
}

export default function Select(props: SelectProps) {
    const {className, options, ...otherProps} = props
    const classes = ["wa-select"]

    if (className) {
        classes.push(className)
    }

    return (
        <div className={classes.join(" ")}>
            <select {...otherProps}>
                {options.map((item: { value: string, label: string }) =>
                    <option value={item.value} key={item.value}>{item.label}</option>)
                }
            </select>
        </div>
    )
};